/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState, useRef, useCallback } from 'react';
import moment from 'moment';

import AppTable from 'components/appTable';
import Gap from 'components/gap';
import PanelBoxLayout from 'components/layout/panelBox';
import { useActions } from 'common/hooks/useActions';
import PrimaryButton from 'components/form/buttons/primaryButton';
import TicketFilterPopup from '../filterForm';

import * as S from './styles';
import * as T from 'common/types';

const urgencyMap = {
  HIGH: 'High',
  MEDIUM: 'Medium',
  LOW: 'Low'
};

const priorityMap = {
  '1': 'Critical',
  '2': 'High',
  '3': 'Moderate',
  '4': 'Low',
  '5': 'Planning'
};

const statusMap = {
  NEW: 'New',
  IN_PROGRESS: 'In Progress',
  CLOSED_BY_USER: 'Closed by User',
  CLOSED_BY_ADMIN: 'Closed by Admin'
};

const PAGE_SIZE = 50;

interface IProps {
  data: any[];
  loading: boolean;
  hasMore?: boolean;
  infiniteScroll?: boolean;
}

export default function TicketTable({ data, loading, infiniteScroll }: IProps) {
  const { ticketsRequestActionNew } = useActions();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({
    status: ''
  });
  const [reqData, setReqData] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const observer = useRef<IntersectionObserver | null>(null);

  const lastItem = useCallback(
    (node: any) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && infiniteScroll && hasMore && !loading) {
          setPage((prev) => prev + 1);
        }
      });
      if (node) observer.current.observe(node);
    },
    [loading, infiniteScroll]
  );

  const fetchData = () => {
    ticketsRequestActionNew(meta, page, PAGE_SIZE);
  };

  function getLabelFromMap<T extends Record<string, string>>(map: T, key: string | number): string {
    const keyStr = key;
    return map[keyStr] || '-';
  }

  useEffect(() => {
    if (data?.length < PAGE_SIZE) {
      setHasMore(false);
    } else {
      setHasMore(true);
    }
  }, [data]);

  useEffect(() => {
    if (infiniteScroll) fetchData();
  }, [page, meta]);

  useEffect(() => {
    // if (Array.isArray(data)) {
    //   if (page === 1 && meta.status === '') {
    //     setReqData(data);
    //     return;
    //   }

    //   if (meta.status === '') {
    //     setReqData((prev) => [...prev, ...data]);
    //     return;
    //   }

    // }
    setFilteredData((prev) => [...data]);
  }, [data]);

  console.log(data);

  return (
    <S.Content>
      <PanelBoxLayout>
        <S.Head>
          {/* <SearchBox
            onChange={(e) => setMeta({ ...meta, search: e })}
            placeholder="Search"
            inputStyle={{ height: 36, borderRadius: 10, fontSize: 12 }}
            style={{ width: 500 }}
            value={meta.search}
          /> */}
          <TicketFilterPopup setFilter={setMeta} filter={meta} setPage={setPage} />
        </S.Head>
        <Gap size="20px" />
        <AppTable
          headers={[
            { id: 1, title: 'Name', dir: 'left' },
            { id: 2, title: 'Category', dir: 'left' },
            { id: 3, title: 'Description', dir: 'left' },
            { id: 4, title: 'Open Date', dir: 'left' },
            { id: 7, title: 'Priority', dir: 'left' },
            { id: 8, title: 'Status', dir: 'left' },
            { id: 9, title: '' }
          ]}
          lastItemRef={lastItem}
          loading={loading}
          data={filteredData}
          altanfeethiFields={{
            name: (item: T.Pages.TicketList) => (
              <S.Div className="text-left">
                {item?.user?.displayName?.length > 15
                  ? item?.user?.displayName?.substring(0, 15) + '...'
                  : item?.user?.displayName}
              </S.Div>
            ),
            category: (item: T.Pages.TicketList) => (
              <S.Div className="text-left">
                {item?.category?.title?.length > 15
                  ? item?.category?.title?.substring(0, 15) + '...'
                  : item?.category?.title}
              </S.Div>
            ),
            description: (item: T.Pages.TicketList) => (
              <S.Div className="text-left">
                {item?.description?.length > 15
                  ? item?.description?.replace(/\r\n/g, '\n')?.substring(0, 15) + '...'
                  : item?.description?.replace(/\r\n/g, '\n')}
              </S.Div>
            ),
            createdAt: (item: T.Pages.TicketList) => (
              <S.Div className="text-left">{moment(item?.createdOn).format('YYYY.MM.DD - HH:MM')}</S.Div>
            ),
            priority: (item: T.Pages.TicketList) => (
              <S.Div className="text-left">{getLabelFromMap(urgencyMap, item?.priority)}</S.Div>
            ),
            status: (item: T.Pages.TicketList) => (
              <S.Div className="text-left">{getLabelFromMap(statusMap, item?.status)}</S.Div>
            ),
            edit: (item: T.Pages.TicketList) => (
              <PrimaryButton
                style={{
                  height: 28,
                  fontSize: 12,
                  background: '#8A93AC',
                  color: 'var(--white)',
                  width: 94,
                  margin: 'auto',
                  borderRadius: 8
                }}
                link={`/panel/ticket/tickets/${item?.id}`}
              >
                Detail
              </PrimaryButton>
            )
          }}
        />
      </PanelBoxLayout>
      {/* {data.totalPages ? (
        <PaginationApp
          page={meta.page}
          count={meta.page_size * data.totalPages}
          handleChangePage={(page: number) => handleChangePage(page)}
          key={data.totalPages}
          pageSize={meta.page_size}
          handleChangeTake={handleChangePageSize}
        />
      ) : (
        <></>
      )} */}
    </S.Content>
  );
}
